import type {
  AvailableBookingSlotsPayload,
  AvailableBookingSlotsOptions,
} from '@brighterly/lib-core-types/reschedule/interfaces'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import { useToast } from '@shared/lib/toast'

import { usePaidStore } from '../store'
import { useAvailableBookingSlotsForPaid } from './available-slots-for-paid.hook'

dayjs.extend(utc)
dayjs.extend(timezone)

export const useAvailableSlots = (payload: AvailableBookingSlotsPayload, options?: AvailableBookingSlotsOptions): void => {
  const paidStore = usePaidStore()
  const toast = useToast()

  paidStore.setProcessing(true)

  if (payload.booking.value) {
    useAvailableBookingSlotsForPaid(payload, options)
  } else {
    paidStore.setProcessing(false)
    toast.error('Unexpected error. Invalid booking')
    return
  }
}
